var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.member)?_c('b-modal',{ref:"teamMemberModal",attrs:{"title":_vm.member.name,"ok-only":"","size":"lg","modal-class":"bootstrap","content-class":"pr-3 pt-3","header-class":"d-flex"}},[_c('TeamMember',{attrs:{"member":_vm.member,"show-name":false}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }